import { forwardRef } from "react"

/**
 * @description
 * This component is used to add a shadow to the pinned columns when the table is scrolled horizontally.
 * It is used in the DataTableHeader and DataTableBody components.
 */
export const DataTablePinnedShadow = forwardRef<
  HTMLDivElement,
  React.TdHTMLAttributes<HTMLDivElement> & {
    isHorizontalScroll: boolean
  }
>(({ children, className, isHorizontalScroll, ...props }, ref) => {
  if (isHorizontalScroll) {
    return (
      <>
        {children}
        <div
          ref={ref}
          // className={cn(
          //   "absolute top-0 left-0 w-full h-full shadow-[0px_2px_8px_0px_rgba(28,33,40,0.25)] [clip-path:inset(0px_-8px_-2px_0px)] pointer-events-none",
          //   className
          // )}
          {...props}
        />
      </>
    )
  }

  return <>{children}</>
})
DataTablePinnedShadow.displayName = "DataTablePinnedShadow"
